import React, { memo, useEffect, useState, useMemo, useCallback } from "react"

import { useApp } from "../../../hooks/useApp"
import { usePage } from "../../../hooks/usePage"
import { useCheckout } from "../../../hooks/useCheckout"
import { useCartSettings } from "../../../hooks/useCartSettings"

export const withCartMini = Component =>
  memo(({ name = "CartMini" }: any) => {
    const { count } = useCheckout()
    const {
      cart: {
        donationTitle,
        donationContent,
        donationImage,
        donationEnabled,
        additionalPageTitle,
        additionalCheckoutButton,
        additionalGeneralFeatureContentsOne,
        additionalGeneralFeatureContentsTwo,
        additionalFooterText,
      },
    } = usePage()

    const { trustSlides, isTrust } = useCartSettings()

    const {
      config: {
        settings: { routes },
      },
      cartHeight,
      setCartHeight,
      globalStateReducer,
    } = useApp()

    const [{ activeCart }, dispatch] = globalStateReducer
    // const [cartItemHeight, setCartItemHeight] = useState(124)
    const [overflowY, setOverflowY] = useState("none")
    const [winH, setWinH] = useState(300)
    const handleCartActive = useCallback(() => {
      dispatch({
        type: "setActiveCart",
        payload: !activeCart,
      })
    }, [activeCart, dispatch])

    const cartUrl = `${routes.CART}`

    useEffect(() => {
      window.addEventListener("resize", getCartItemHeight)
      window.addEventListener("load", getCartItemHeight)
      function getCartItemHeight() {
        const cartSection = document.getElementById("CheckoutSection")?.clientHeight
        const innerPadding = parseInt(window.getComputedStyle(document.getElementById("MiniCartInner"), null).paddingTop)
        const windowH = window.innerHeight
        const cartItemH = windowH - cartSection - innerPadding
        setCartHeight(cartItemH)
        setWinH(windowH)
      }
      getCartItemHeight()
      if (count > 2) {
        setOverflowY("scroll")
      } else {
        setOverflowY("none")
      }
    }, [count])
    Component.displayName = name
    return useMemo(
      () => (
        <Component
          activeCart={activeCart}
          handleCartActive={handleCartActive}
          cartUrl={cartUrl}
          count={count}
          winH={winH}
          cartItemHeight={cartHeight}
          overflowY={overflowY}
          donationEnabled={donationEnabled}
          donationTitle={donationTitle}
          donationContent={donationContent}
          donationImage={donationImage}
          isTrust={isTrust}
          trustSlides={trustSlides}
          additionalPageTitle={additionalPageTitle}
          additionalCheckoutButton={additionalCheckoutButton}
          additionalGeneralFeatureContentsOne={additionalGeneralFeatureContentsOne}
          additionalGeneralFeatureContentsTwo={additionalGeneralFeatureContentsTwo}
          additionalFooterText={additionalFooterText}
        />
      ),
      [
        activeCart,
        cartUrl,
        handleCartActive,
        count,
        winH,
        // cartItemHeight,
        winH,
        cartHeight,
        overflowY,
        donationEnabled,
        donationTitle,
        donationContent,
        donationImage,
        isTrust,
        trustSlides,
        additionalPageTitle,
        additionalCheckoutButton,
        additionalGeneralFeatureContentsOne,
        additionalGeneralFeatureContentsTwo,
        additionalFooterText,
      ]
    )
  })
